import React from 'react'
import btnCss from "./actionButton.module.scss";
import useActionHook from '../../../hooks/useActionHook';



function ActionButton(props) {

  return (
    <button
      onClick={useActionHook(props.data)}
      className={`${btnCss.tbx_action_btn}`}
    >
      Save Contact
    </button>
  );
}

export default ActionButton